import moment from "moment";
import propTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { faAt, faBuilding, faCity, faHouseChimney } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid } from "@material-ui/core";

import { colorIcons, couleurZaDeploiement } from "../../../enums";
import { setLogoFromDsp } from "../../../utils";
import "./Legende.scss";

const Legende = ({
  dsp,
  optionSelectedConfigCarte,
  zoom,
  ZOOM_LEVEL_IMB,
  ZOOM_LEVEL_FTTE,
  MAX_ZOOM_DISPLAY_SRO,
  MIN_ZOOM_DISPLAY_SRO,
  MAX_ZOOM_DISPLAY_AMII,
  MIN_ZOOM_DISPLAY_AMII,
}) => {
  const [listeLegendes, setListeLegendes] = useState([]);

  const updateLegende = () => {
    const listeLegendesTemp = [];

    if (zoom >= ZOOM_LEVEL_IMB) {
      if (dsp.codeReseau !== "AI-DOUB") {
        optionSelectedConfigCarte.IMB_RAC &&
          listeLegendesTemp.push({
            icons: [faAt],
            label: "Raccordé",
            color: colorIcons.raccorde,
          });
      }

      optionSelectedConfigCarte.IMB_ELIG &&
        listeLegendesTemp.push({
          icons: [faBuilding, faHouseChimney],
          label: "Eligible",
          color: colorIcons.deploye,
        });

      optionSelectedConfigCarte.IMB_PROELIG &&
        listeLegendesTemp.push({
          icons: [faBuilding, faHouseChimney],
          label: "Prochainement éligible",
          color:
            dsp.codeReseau === "AI-VENU" ? colorIcons.gelVendee : colorIcons.prochainementEligible,
        });

      optionSelectedConfigCarte.IMB_TRAVAUX_RUE &&
        listeLegendesTemp.push({
          icons: [faBuilding, faHouseChimney],
          label: "Travaux en cours dans votre rue",
          color: colorIcons.travauxRueVendee,
        });

      optionSelectedConfigCarte.IMB_TRAVAUX_SECTEUR &&
        listeLegendesTemp.push({
          icons: [faBuilding, faHouseChimney],
          label: "Travaux en cours dans votre secteur",
          color: colorIcons.travauxSecteurVendee,
        });

      optionSelectedConfigCarte.IMB_GELCOM &&
        listeLegendesTemp.push({
          icons: [faBuilding, faHouseChimney],
          label: "Correction technique en cours",
          color: colorIcons.gelCommercial,
        });

      optionSelectedConfigCarte.IMB_DEMANDE &&
        listeLegendesTemp.push({
          icons: [faBuilding, faHouseChimney],
          label: "Raccordable sur demande",
          color: dsp.codeReseau === "AI-VENU" ? colorIcons.demandeVendee : colorIcons.demande,
        });

      optionSelectedConfigCarte.IMB_ETUDE &&
        listeLegendesTemp.push({
          icons: [faBuilding, faHouseChimney],
          label: "En cours d'étude",
          color: dsp.codeReseau === "AI-VENU" ? colorIcons.cibleVendee : colorIcons.cible,
        });

      optionSelectedConfigCarte.IMB_BLOC_COLLECTIF_TIERS &&
        listeLegendesTemp.push({
          icons: [faBuilding, faHouseChimney],
          label: "Blocage tiers",
          color: colorIcons.blocCollectifTiers,
        });

      optionSelectedConfigCarte.FTTE &&
        zoom >= ZOOM_LEVEL_FTTE &&
        listeLegendesTemp.push({
          icons: [faCity],
          label: "Entreprise Eligible",
          color: colorIcons.deploye,
        });
    }

    if (dsp.codeReseau === "AI-VENU") {
      optionSelectedConfigCarte.ZONE_RADIO &&
        listeLegendesTemp.push({
          color: couleurZaDeploiement.ZONE_RADIO,
          label: "Très Haut Débit Radio",
        });

      if (zoom >= MAX_ZOOM_DISPLAY_SRO && zoom <= MIN_ZOOM_DISPLAY_SRO) {
        optionSelectedConfigCarte.SRO_DEP_201820 &&
          listeLegendesTemp.push({
            color: couleurZaDeploiement.ZASROCommercialisable20182020,
            label: "Déploiement en 2018 - 2020",
          });

        optionSelectedConfigCarte.SRO_DEP_2021 &&
          listeLegendesTemp.push({
            color: couleurZaDeploiement.ZASROCommercialisable2021,
            label: "Déploiement en 2021",
          });

        optionSelectedConfigCarte.SRO_DEP_2022 &&
          listeLegendesTemp.push({
            color: couleurZaDeploiement.ZASROCommercialisable2022,
            label: "Déploiement en 2022",
          });

        optionSelectedConfigCarte.SRO_DEP_2023 &&
          listeLegendesTemp.push({
            color: couleurZaDeploiement.ZASROCommercialisable2023,
            label: "Déploiement en 2023",
          });
      }

      optionSelectedConfigCarte.ZONE_AMII &&
        zoom >= MAX_ZOOM_DISPLAY_AMII &&
        zoom <= MIN_ZOOM_DISPLAY_AMII &&
        listeLegendesTemp.push({
          color: couleurZaDeploiement.ZAAMII,
          label: "Zones privées de déploiement de la fibre",
        });
    } else if (zoom >= MAX_ZOOM_DISPLAY_SRO && zoom <= MIN_ZOOM_DISPLAY_SRO) {
      optionSelectedConfigCarte.SRO_OPEN &&
        listeLegendesTemp.push({
          color: couleurZaDeploiement.ZaSroOpen,
          label: "Ouvertes commercialement",
        });

      optionSelectedConfigCarte.SRO_SOON &&
        listeLegendesTemp.push({
          color: couleurZaDeploiement.ZaSroSoon,
          label: "Ouvertes prochainement",
        });
      // On regroupe les zones de déploiement N0,N1,N2 en NX pour le marche AI-MNUM
      if (dsp.codeReseau === "AI-MNUM") {
        optionSelectedConfigCarte.SRO_YEAR_NX &&
          listeLegendesTemp.push({
            color: couleurZaDeploiement.ZaSroYearNX,
            label: `Travaux en cours`,
          });
      } else {
        optionSelectedConfigCarte.SRO_YEAR_N0 &&
          listeLegendesTemp.push({
            color: couleurZaDeploiement.ZaSroYearN0,
            label: `Déploiement en ${moment().year()}`,
          });

        optionSelectedConfigCarte.SRO_YEAR_N1 &&
          listeLegendesTemp.push({
            color: couleurZaDeploiement.ZaSroYearN1,
            label: `Déploiement en ${moment().year() + 1}`,
          });

        optionSelectedConfigCarte.SRO_YEAR_N2 &&
          listeLegendesTemp.push({
            color: couleurZaDeploiement.ZaSroYearN2,
            label: `Déploiement en ${moment().year() + 2}`,
          });
      }
    }

    setListeLegendes(listeLegendesTemp);
  };

  useEffect(() => {
    updateLegende();
  }, [zoom, optionSelectedConfigCarte]);

  return (
    <Grid container direction="column" wrap="nowrap">
      <Grid item xs={12} className="legende-title-container">
        <a className="legende-title" href={dsp.urlSite} target="_blank" rel="noreferrer">
          {setLogoFromDsp(dsp)}
        </a>
      </Grid>
      {listeLegendes.length > 0 && (
        <Grid className="legende-content-container" item xs={12}>
          {listeLegendes.map(legende => (
            <Grid key={legende.label} item xs={12} className="legende-element">
              <Grid item className="legende-element-container">
                {legende.icons &&
                  legende.icons.map((image, index) => (
                    <div key={index} className="legende-element-image ai-icon">
                      <FontAwesomeIcon icon={image} size="sm" style={{ color: legende.color }} />
                    </div>
                  ))}
                {!legende.icons && (
                  <div
                    className="legende-element-square"
                    style={{
                      backgroundColor: legende.color,
                    }}
                  />
                )}
              </Grid>
              <Grid item xs={12} className="legende-element-container">
                <span className="legende-element-texte">{legende.label}</span>
              </Grid>
            </Grid>
          ))}
        </Grid>
      )}
    </Grid>
  );
};

Legende.propTypes = {
  dsp: propTypes.shape({
    logo: propTypes.string,
    codeMarche: propTypes.string,
    codeReseau: propTypes.string,
    libelle: propTypes.string,
    urlSite: propTypes.string,
    urlZonesDeploiement: propTypes.string,
    urlFibreFtth: propTypes.string,
    urlFibreSurDemande: propTypes.string,
    urlFibreFtte: propTypes.string,
    urlChangementAdresse: propTypes.string,
    urlListeOperateur: propTypes.string,
    urlPreparation: propTypes.string,
  }).isRequired,
  optionSelectedConfigCarte: propTypes.shape({
    LAYER_PLAN: propTypes.bool,
    LAYER_SAT: propTypes.bool,
    ALL_ZONES: propTypes.bool,
    SRO_DEP_201820: propTypes.bool,
    SRO_DEP_2021: propTypes.bool,
    SRO_DEP_2022: propTypes.bool,
    SRO_DEP_2023: propTypes.bool,
    SRO_OPEN: propTypes.bool,
    SRO_SOON: propTypes.bool,
    SRO_YEAR_NX: propTypes.bool,
    SRO_YEAR_N0: propTypes.bool,
    SRO_YEAR_N1: propTypes.bool,
    SRO_YEAR_N2: propTypes.bool,
    ZONE_RADIO: propTypes.bool,
    ZONE_AMII: propTypes.bool,
    ALL_STATUSES: propTypes.bool,
    IMB_RAC: propTypes.bool,
    IMB_ELIG: propTypes.bool,
    IMB_PROELIG: propTypes.bool,
    IMB_GELCOM: propTypes.bool,
    IMB_ETUDE: propTypes.bool,
    IMB_TRAVAUX_SECTEUR: propTypes.bool,
    IMB_TRAVAUX_RUE: propTypes.bool,
    IMB_DEMANDE: propTypes.bool,
    IMB_BLOC_COLLECTIF_TIERS: propTypes.bool,
    FTTE: propTypes.bool,
  }).isRequired,
  zoom: propTypes.number.isRequired,
  ZOOM_LEVEL_IMB: propTypes.number.isRequired,
  ZOOM_LEVEL_FTTE: propTypes.number.isRequired,
  MAX_ZOOM_DISPLAY_SRO: propTypes.number.isRequired,
  MIN_ZOOM_DISPLAY_SRO: propTypes.number.isRequired,
  MAX_ZOOM_DISPLAY_AMII: propTypes.number.isRequired,
  MIN_ZOOM_DISPLAY_AMII: propTypes.number.isRequired,
};

export default Legende;
